import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../components/breadcrumbs/Breadcrumbs";
import api from "../api/api";
import uuidv4 from "../utils/uuid";

export default function TicketView() {
  const navigate = useNavigate();

  const { bookingId } = useParams();
  const [paymentData, setPaymentData] = useState(null);

  useEffect(() => {
    let paymentDataRes = null;

    try {
      paymentDataRes = JSON.parse(sessionStorage.getItem(`pdr_${bookingId}`));
    } catch (err) {
      console.error("Error parsing payment data. Error: ", err);
    }

    if (paymentDataRes) {
      setPaymentData(paymentDataRes);
    } else {
      navigate("/");
    }
  }, [bookingId, navigate]);

  const fetchDownloadTicket = useCallback(async () => {
    const res = await api.downloadTicket(bookingId);
    if (res?.status === 200) {
      const url = window.URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = url;
      link.download = `SHOHOZ.COM_TICKET${uuidv4()}.pdf`;
      link.dispatchEvent(new MouseEvent("click"));
    }
  }, [bookingId]);

  function handleDownloadTicket() {
    fetchDownloadTicket();
  }

  return (
    <>
      <Breadcrumbs activeId={7} />

      <div className="container-fluid bg-light py-3 px-3">
        <div className="row justify-content-center">
          <div className="col-lg-7">
            <div className="bg-white rounded p-4 shadow-sm">
              <h5 className="fw-semibold mb-4">Order Details</h5>
              <div className="row">
                <div className="col-md-4">
                  <span className="text-secondary small">Customer Name</span>
                  <br />
                  <b>
                    {paymentData?.customer?.first_name}{" "}
                    {paymentData?.customer?.last_name}
                  </b>
                </div>
                <div className="col-md-4">
                  <span className="text-secondary small">Phone Number</span>
                  <br />
                  <b>{paymentData?.customer?.phone}</b>
                </div>
                <div className="col-md-4">
                  <span className="text-secondary small">Booking Date</span>
                  <br />
                  <b>{paymentData?.bookedOn?.split(" ")[0]}</b>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <span className="text-secondary small">Park Name</span>
                  <br />
                  <b>{paymentData?.park}</b>
                </div>
                <div className="col-md-4">
                  <span className="text-secondary small">Branch</span>
                  <br />
                  <b>
                    {" "}
                    {paymentData?.membership?.length > 0
                      ? "All"
                      : paymentData?.branch}
                  </b>
                </div>
                <div className="col-md-4">
                  <span className="text-secondary small">Order ID</span>
                  <br />
                  <b>{paymentData?.pnr}</b>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-3">
            <div
              className="border-bottom"
              style={{
                backgroundColor: "#e6f4ea",
                padding: "1rem",
                fontSize: "0.85rem",
                borderRadius: "0.25rem",
                height:'100%'
              }}
            >
              <strong>Terms & Condition</strong>
              <ul className="mb-0">
                <li>All tickets are <b>non-exchangeable, non-cancelable, and non-refundable</b></li>
                <li>Outside food is <b>not allowed</b> inside the park</li>
                <li>All standard <b>ticket conditions apply</b></li>
                <li>Children must be <b>under {`4'3"`}</b> to qualify for child tickets</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10 mt-lg-4">
            <div className="bg-white p-4 rounded">
              <div className="text-center">
                <button
                  className="btn btn-success fw-bold"
                  type="button"
                  onClick={handleDownloadTicket}
                >
                  DOWNLOAD TICKET
                </button>
              </div>
            </div>
          </div>
        </div>
        
      </div>
    </>
  );
}
